import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';
import ResizeObserver from 'resize-observer-polyfill';
import alignWidth from '../tools/alignWidth';
import ConfigConsumer from '../ConfigConsumer';
import FormContext from '../tools/FormContext';
import { FormControlGroupWrapContext } from '../tools/FormWrapContext';

var FormControlAligner = /*#__PURE__*/function (_PureComponent) {
  _inherits(FormControlAligner, _PureComponent);

  var _super = _createSuper(FormControlAligner);

  function FormControlAligner() {
    _classCallCheck(this, FormControlAligner);

    return _super.apply(this, arguments);
  }

  _createClass(FormControlAligner, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this = this;

      // 如果table尺寸变化，重新计算尺寸
      var resizeObserver = this.resizeObserver = new ResizeObserver(function () {
        if (!_this.initialized) {
          _this.update();
        }
      });
      resizeObserver.observe(findDOMNode(this));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.update();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.resizeObserver && this.resizeObserver.disconnect();
    }
  }, {
    key: "update",
    value: function update() {
      var node = findDOMNode(this);

      if (!(node !== null && node !== void 0 && node.offsetWidth)) {
        return;
      }

      var alignControlWidth = this.props.alignControlWidth;

      if (alignControlWidth) {
        alignWidth(node.querySelectorAll('.jmtd-form-control-label'));
        alignWidth(node.querySelectorAll('.jmtd-form-control-button-label'));
      }

      this.initialized = true;
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return /*#__PURE__*/React.createElement(React.Fragment, null, children);
    }
  }]);

  return FormControlAligner;
}(PureComponent);

FormControlAligner.propTypes = {
  children: PropTypes.node,
  alignControlWidth: PropTypes.bool
};
FormControlAligner.defaultProps = {
  children: null,
  alignControlWidth: null
};

function FormControlGroupWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(ConfigConsumer, {
    context: FormContext
  }, function (_ref2) {
    var alignControlWidth = _ref2.alignControlWidth;
    return /*#__PURE__*/React.createElement(FormControlAligner, {
      alignControlWidth: alignControlWidth
    }, children);
  });
}

FormControlGroupWrapper.propTypes = {
  children: PropTypes.node
};
FormControlGroupWrapper.defaultProps = {
  children: null
};
var FormControlGroup = FormControlGroupWrapContext.WrapperComponent(FormControlGroupWrapper);
export default FormControlGroup;